import { render, staticRenderFns } from "./RemarkSign.vue?vue&type=template&id=044077f5&scoped=true&"
import script from "./RemarkSign.vue?vue&type=script&lang=js&"
export * from "./RemarkSign.vue?vue&type=script&lang=js&"
import style0 from "./RemarkSign.vue?vue&type=style&index=0&id=044077f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044077f5",
  null
  
)

export default component.exports